import { NestedItemBasicInfo, NestedProjectExplorer } from '@tableau/nested-project-explorer';
import { CheckBoxWithLabelWidget, CompactInlineAlertWidget, InlineAlertType, TabStyles } from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { checkboxStyle } from '~src/catalog/styles/LabelStyles';
import { Messages } from '~src/codegen/Localize';
import { projectPickerFieldStyles, projectPickerStyles } from '~src/projects/components/styles/ProjectPickerStyles';

/** TEST IDS */
export const MESSAGE_TEST_ID = 'dialog-message';

const messageStyles: React.CSSProperties = { marginBottom: TabStyles.Spacing.LargeSpace, marginTop: '0px' };
const MOVE_TABLES_WITH_DB_TEST_ID: string = 'move-tables-along-with-db-checkbox';

export type MoveContentDialogBodyState = {
  selectedItem: NestedItemBasicInfo;
  moveDependentContent: boolean ;
}

export type MoveContentDialogBodyProps = {
  prompt: string;
  targets: NestedProjectExplorer.Props | null;
  movingDatabases: boolean;
  tablesInProjectsUIFeatureEnabled: boolean;
}

export type MoveContentDialogProps = ReactActionDialogBodyProps<MoveContentDialogBodyProps, MoveContentDialogBodyState>;

export function MoveContentDialogBody(props: MoveContentDialogProps) {
  return <>
    <p data-tb-test-id={MESSAGE_TEST_ID} style={messageStyles}>
      {props.prompt}
    </p>
    <div className={classes(projectPickerStyles, projectPickerFieldStyles)} style={{ height: 300 }}>
      <NestedProjectExplorer
        topLevelDestinationStatus={props.targets.topLevelDestinationStatus}
        projects={props.targets.projects}
        onSelectedProjectChanged={items => props.updateDialogState({ selectedItem : items })} />
    </div>
    { props.movingDatabases ?

      props.tablesInProjectsUIFeatureEnabled ?

      <div>
        <CheckBoxWithLabelWidget
        label={ Messages.moveDatabasesChildrenMessage() }
        testId={MOVE_TABLES_WITH_DB_TEST_ID}
        checked={props.dialogState.moveDependentContent}
        handleChange={(checked: boolean) => props.updateDialogState({ moveDependentContent: checked })}
        removeLeftMargin={true}
        containerStyle={checkboxStyle} />
      </div>
      :
      <div>
        <CompactInlineAlertWidget
          testId='move-database-assets-inline-alert'
          type={InlineAlertType.Info}
          children={ Messages.moveDatabasesChildrenWarning() }
          style={{ marginTop: '8px'}}/>
      </div>
      : null }
  </>;
}
